import * as Yup from "yup";
import checkout from "./form";

const {
  formField: { code, auth },
} = checkout;

export default (t) =>
  Yup.object().shape({
    [code.name]: Yup.string()
      .matches(/^[0-9]+$/, {
        message: t("Code should be a number"),
        excludeEmptyString: true,
      })
      .required(t(code.errorMsg)),
    [auth.name]: Yup.string()
      .matches(/^[0-9]+$/, {
        message: t("Input should be a number"),
        excludeEmptyString: true,
      })
      .length(4, t("Input should be 4 number long"))
      .required(t(auth.errorMsg)),
  });
